import { Pipe, PipeTransform } from '@angular/core';
import { padLeft } from '@shared/functions';

@Pipe({
    name: 'identNumber',
    standalone: false
})
export class IdentNumberPipe implements PipeTransform {
    transform(id: number): string {
        return padLeft(id);
    }
}
